import { DEFAULT_DENSITY, isUiDensity, type UiDensity } from "../constants/density";

export const DENSITY_STORAGE_KEY = "exybox_density_v1";

export interface DensityPreference {
  desktop: UiDensity;
  mobile: UiDensity;
}

export const DEFAULT_DENSITY_PREFERENCE: DensityPreference = {
  desktop: DEFAULT_DENSITY,
  mobile: DEFAULT_DENSITY,
};

export const readDensityPreference = (): DensityPreference => {
  try {
    const raw = localStorage.getItem(DENSITY_STORAGE_KEY);
    if (!raw) {
      return DEFAULT_DENSITY_PREFERENCE;
    }

    try {
      const parsed = JSON.parse(raw) as Partial<DensityPreference>;
      return {
        desktop: isUiDensity(parsed.desktop) ? parsed.desktop : DEFAULT_DENSITY,
        mobile: isUiDensity(parsed.mobile) ? parsed.mobile : DEFAULT_DENSITY,
      };
    } catch {
      return DEFAULT_DENSITY_PREFERENCE;
    }
  } catch {
    // localStorage throws in private browsing; density preference is non-critical.
    return DEFAULT_DENSITY_PREFERENCE;
  }
};

export const writeDensityPreference = (pref: DensityPreference): void => {
  try {
    localStorage.setItem(DENSITY_STORAGE_KEY, JSON.stringify(pref));
  } catch {
    // localStorage throws in private browsing; density preference is non-critical.
  }
};

export const clearDensityPreference = (): void => {
  try {
    localStorage.removeItem(DENSITY_STORAGE_KEY);
  } catch {
    // localStorage throws in private browsing; density preference is non-critical.
  }
};
